(() => {
  const INTERSECTION_THRESHOLD = 0.3;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  const gallery = document.querySelector('media-gallery[data-video-autoplay]');
  if (!gallery) return;

  const postIframeCommand = (iframe, message) => {
    if (iframe?.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify(message), '*');
    }
  };

  const pauseVideo = (slide) => {
    const deferredMedia = slide.querySelector('deferred-media');
    if (!deferredMedia?.getAttribute('loaded')) return;

    const video = deferredMedia.querySelector('video');
    if (video) { video.pause(); return; }

    postIframeCommand(
      deferredMedia.querySelector('.js-youtube'),
      { event: 'command', func: 'pauseVideo', args: '' }
    );
    postIframeCommand(
      deferredMedia.querySelector('.js-vimeo'),
      { method: 'pause' }
    );
  };

  const playVideo = (slide) => {
    if (slide.querySelector('[data-video-toggle-container][data-user-paused]')) return;

    const deferredMedia = slide.querySelector('deferred-media');
    if (!deferredMedia) return;

    const modalOpener = slide.querySelector('modal-opener');
    if (modalOpener) modalOpener.style.display = 'none';

    deferredMedia.style.display = 'block';

    if (!deferredMedia.getAttribute('loaded')) {
      deferredMedia.loadContent(false);
    }

    const poster = deferredMedia.querySelector('.deferred-media__poster');
    if (poster) poster.style.display = 'none';

    const video = deferredMedia.querySelector('video');
    if (video) {
      video.muted = true;
      requestAnimationFrame(() => video.play().catch(() => {}));
      return;
    }

    postIframeCommand(
      deferredMedia.querySelector('.js-youtube'),
      { event: 'command', func: 'playVideo', args: '' }
    );
    postIframeCommand(
      deferredMedia.querySelector('.js-vimeo'),
      { method: 'play' }
    );
  };

  const videoSlides = gallery.querySelectorAll(
    '[data-media-type="video"], [data-media-type="external_video"]'
  );

  if (!videoSlides.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          playVideo(entry.target);
        } else {
          pauseVideo(entry.target);
        }
      });
    },
    { threshold: INTERSECTION_THRESHOLD }
  );

  videoSlides.forEach((slide) => observer.observe(slide));
})();
